import { loadModule } from 'vue3-sfc-loader';
import config from '@/config/config';
import * as Vue from 'vue';
import * as vant from 'vant';
import * as FeUtils from '@/fe/utils';
import * as FeFilter from '@/fe/filter';
import { defineAsyncComponent } from 'vue';

const loadAssets = (url: string) => {
  fetch(url)
    .then(res => res.text())
    .then(text => {
      const style = Object.assign(document.createElement('style'), { textContent: text });
      document.head.appendChild(style);
    });
};

loadAssets(config.staticURL + '/eco/mobile/style.css');

const options = {
  moduleCache: { vue: Vue, vant: vant, '@fe/utils': FeUtils, '@fe/filter': FeFilter },
  getFile: async (url: string) => {
    const res = await fetch(url);
    if (!res.ok) throw Object.assign(new Error(res.statusText + ' ' + url), { res });
    return {
      getContentData: (asBinary: boolean) => (asBinary ? res.arrayBuffer() : res.text())
    };
  },
  addStyle(textContent: string) {
    const style = Object.assign(document.createElement('style'), { textContent });
    document.head.appendChild(style);
  },
  log(type: string, ...args: any[]) {
    (console as any)[type](...args);
  }
};
// 由于是异步组件 在打开时再加载会很慢  先提前加载一次
loadModule(config.staticURL + '/eco/mobile/print-template.umd.js', options);

const PrintTemplate = defineAsyncComponent(() =>
  loadModule(config.staticURL + '/eco/mobile/print-template.umd.js', options)
);
export default PrintTemplate;
